// import { Outlet, useNavigate } from 'react-router-dom';
// import './Dashboard.css';
// import { useAuth0 } from '@auth0/auth0-react';
// import SideBar from '../components/SideBarNew';
// import { useEffect, useState } from 'react';
// import { Box,CircularProgress, Typography } from '@mui/material';
// import { ApiService } from '../API/AxiosInstance';
// import { subscribeToMessages } from '../firebase';
// import { captureException } from '@sentry/react';
// import axios from 'axios';
// import { ReactComponent as BellIcon } from '../img/bell.svg'
// import { onMessage } from 'firebase/messaging';
// import { messaging } from '../firebase';
// import { toast } from "react-toastify";
// import StyledToastContainer from '../pages/Notifications/ToastContainer';
// import { deleteDeviceToken } from '../utils/deviceTokenDelete';

// export default function Dashboard() {
//   const [loading, setLoading] = useState(false)
//   const {
//     user,
//     isAuthenticated,
//     getAccessTokenSilently,
//     logout
//   } = useAuth0();
//   const navigate = useNavigate();
//   const [loginClicked, setLoginClicked] = useState(false)
//   const [logoutClicked, setLogoutClicked] = useState(false)
//   const [token, setToken] = useState('')
//   const [uiLoading, setUiLoading]  = useState(true)
//   const localUserData = JSON.parse(localStorage.getItem('userData')) || ''
//   const [localData, setLocalData] = useState(localUserData)
//   const [notifications, setNotifications] = useState([]);
//   const storedToken = localStorage.getItem('token');

//   // useEffect(() => {
//   //     const unsubscribe = onMessage(messaging, (payload) => {
//   //       console.log("FCMessagenav", payload);
  
//   //       const title =
//   //         payload?.notification?.title || payload?.data?.title || "New Notification";
//   //       const body = payload?.notification?.body || payload?.data?.body || "";
  
//   //       console.log("titlebody didebar ",title,body)
//   //       // show toast
//   //       //  pushNotification(title, body);
//   //             toast(
//   //       <Box sx={{display:"flex", justifyContent:"center", gap:1, alignItems:"center"}}>
//   //           <BellIcon />
//   //            <Box
//   //             sx={{
//   //               display: "flex",
//   //               flexDirection: "column",
//   //               gap: 1,
//   //               flex: 1,
//   //               width:"80%",
//   //             }}
//   //           >
//   //             <Typography
//   //               sx={{
//   //                 fontSize: "14px",
//   //                 color: "#111111",
//   //                 fontWeight: "500",
//   //                 letterSpacing: "0%",
//   //               }}
//   //             >
//   //               {title}
//   //             </Typography>
//   //             <Typography
//   //               sx={{
//   //                 fontSize: "12px",
//   //                 color: "#11111199",
//   //                 fontWeight: "400",
//   //                 letterSpacing: "0%",
//   //               }}
//   //             >
//   //               {body}
//   //             </Typography>
//   //           </Box>
//   //       </Box>
//   //          ,
//   //       {
//   //         autoClose: 5000, // auto dismiss in 5s
//   //         closeOnClick: true,
//   //         pauseOnHover: true,
//   //         draggable: true,
//   //         hideProgressBar: true,
//   //         position: "top-center", // like your design
//   //       }
//   //     );
//   //   });
  
//   //     return () => unsubscribe();
//   //   }, []);


//   const checkSubIdArraival = async(auth0Id) => {
//     try {
//       const response =  await ApiService().post('users/by-auth0Id', {auth0Id: auth0Id})
//       console.log("response?.data?.user?.userId ",response?.data?.user)
//       const { firstName, lastName } = response?.data?.user;
//       localStorage.setItem("firstName",firstName)
//       localStorage.setItem("lastName",lastName)
//       console.log("DOB ",response?.data?.user,response?.data?.user?.dateOfBirth)
//       // navigate('/Questionnaire')
//      if(response?.data?.user?.dateOfBirth) {

//       verifyQuestionarComplete(response?.data?.user?.userId)
//      } else {
//       console.log("within else ",response)
//       let getUserData = JSON.parse(localStorage.getItem('userData')) || {}
//       console.log("getUserData ",getUserData)
//       getUserData.sub_id = response?.data?.user?.userId
//       console.log("after getUserData ",getUserData)
//       localStorage.setItem('userData',JSON.stringify(getUserData))
//       setUiLoading(false)
//       console.log("Before navigate");
// navigate("/Signup", { replace: true });
// console.log("After navigate");
        
//      }

//    } catch(error) {
//     captureException(error)
//    }
//   }
// console.log("uiLoading ",uiLoading)
//   useEffect(() => {
//     if(localStorage.getItem('login') && !isAuthenticated) setLoading(true)
//   },[isAuthenticated])


// const verifyQuestionarComplete = async(user_id, token) => {
//   console.log("user_id ",user_id)
//   try {
//       const response = await  ApiService().get(`users/${user_id}/onboarding/status`)
//       if(response?.data?.status) {
//         if(response?.data?.status?.completedQuestionnaire == false && !localStorage.getItem('questionaire_skipped')) {
//           setLoading(false)
//           setUiLoading(false)
//           navigate('/Questionnaire')
        
//         }
//         setLoading(false)
//       }
//   } catch (error) {
//     setLoading(false)
//     setUiLoading(false)
//     captureException(error)
//   }
//   setUiLoading(false)
// }

//   useEffect(() => {
//     subscribeToMessages();
//   }, []);


//   useEffect(() => {
//   const handleLoading = async () => {
//     if (isAuthenticated && user) {
//       try {
//         setLoading(true);

//         const res = await getAccessTokenSilently();
//         localStorage.setItem('token', res);
//         setToken(res);
//         const tokenIssuedAt = await getIssuedAtFromToken(res)

//         if (!localStorage.getItem('userData')) {
//           console.log("Checking subscription for",user, user?.sub);
//           // await checkAlreadyLoggedIn(res,user?.sub_id,tokenIssuedAt?.iat)
//           setTimeout(async() => {
//             await checkSubIdArraival(user?.sub);
//           },500)
          
//         } else {
//           console.log("User data already present, setting it again");
//           localStorage.setItem('userData', JSON.stringify(user));
//           setUiLoading(false);
//         }

//       } catch (error) {
//         if (error?.message === "Unknown or invalid refresh token.") {
//           // await deleteDeviceToken()
//           await invalidateSession()
//           await logoutAfterTokenExpired();
//           localStorage.clear();
//           localStorage.setItem('logout', true);
//           logout({ logoutParams: { returnTo: window.location.origin } })
//         } else {
//           console.error("Error in handleLoading:", error);
//         }
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   handleLoading();
// }, [isAuthenticated, user, getAccessTokenSilently, logout]);

// const getIssuedAtFromToken = (token) => {
//    const base64Url = token.split('.')[1]; 
//     const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split('')
//         .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//         .join('')
//     );
//     return JSON.parse(jsonPayload);
// }
// const rawAxios = axios.create();

//   const checkAlreadyLoggedIn = async(token,userId,issuedAt) => {
//       try {
//         console.log("ihave ",storedToken)
//         const response = await rawAxios.post(`${process.env.REACT_APP_BASE_URL}users/${userId}/sessions`, {issuedAt: issuedAt}, {headers:{'Authorization': `Bearer ${token ? token : null}`}})
//         console.log("alreadfy response ",response)
//       } catch(error) {
//         console.log("checkAlreadyLoggedIn error ",error)
//       }
//   }

// const invalidateSession = async() => {
//     try {
//       await axios.post(`${process.env.REACT_APP_BASE_URL}users/${user?.sub_id}/sessions/invalidate`, {}, {headers:{'Authorization': `Bearer ${storedToken ? storedToken : null}`}})

//     } catch(error) {
//       console.log("invalidateSession error ",error)
//     }
// }

//   const logoutAfterTokenExpired = async() => {
//       try {
//         await axios.get(`${process.env.REACT_APP_BASE_URL}oauth/logout`, {headers:{'Authorization': `Bearer ${storedToken ? storedToken : null}`}})
        
//       } catch(error) {
//         console.log("logoutAfterTokenExpired error ",error)
//       }
//   }

//   // useEffect(() => {
//   //   if( !isAuthenticated && (loginClicked || localStorage.getItem('logout'))) {
//   //     setLoading(false)
//   //     setLoginClicked(false)
//   //     localStorage.removeItem('logout')
//   //   }
//   // },[isAuthenticated])
//     useEffect(() => {
//     if( !isAuthenticated && (loginClicked)) {
//       setLoading(false)
//       setLoginClicked(false)
//       localStorage.removeItem('logout')
//     }
//   },[isAuthenticated])

//   useEffect(() => {
//     if(!isAuthenticated) {
//       setLoading(true)
//     }
//   },[isAuthenticated])

//   useEffect(() => {
//     if(storedToken && user && isAuthenticated) {
//       setLoading(false)
//     }
//   },[storedToken, user, isAuthenticated])

// if (loading && (!token && !localStorage.getItem("token"))) return (
//      <Box sx={{  width: '100vw', height: "100vh", display:"flex", justifyContent:"center", alignItems:"center" }}>
//    <CircularProgress size="lg" sx={{width:"80px", height:"80px"}} />
//   </Box> 
//   )
// // if(!loading && (!token && !localStorage.getItem("token"))) return  navigate('/')
// if(uiLoading) return  <Box sx={{ width: '100vw', height: "100vh", display:"flex", justifyContent:"center", alignItems:"center" }}>
// <CircularProgress size="lg" sx={{width:"80px", height:"80px"}} />
// </Box> 
//   return (<>

//       {storedToken &&
//       (<SideBar setLogoutClicked={setLogoutClicked} logoutClicked={logoutClicked}>
//         <Box sx={{margin:"0 auto", width:"100%"}}>
//           <Box sx={{width:"100%"}}>
//             <StyledToastContainer  limit={3} />
//           </Box>
//         <Outlet />
//         </Box>
//     </SideBar>)}

//   </>

//   );
// }

import { Outlet, useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { useAuth0 } from '@auth0/auth0-react';
import SideBar from '../components/SideBarNew';
import { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ApiService } from '../API/AxiosInstance';
import { subscribeToMessages } from '../firebase';
import { captureException } from '@sentry/react';
import axios from 'axios';
import { ReactComponent as BellIcon } from '../img/bell.svg'
import { onMessage } from 'firebase/messaging';
import { messaging } from '../firebase';
import { toast } from "react-toastify";
import StyledToastContainer from '../pages/Notifications/ToastContainer';
import { deleteDeviceToken } from '../utils/deviceTokenDelete';

// Dedicated flag for "onboarding fully verified complete" — kept separate from
// 'userData' (which just caches the Auth0 user object for display purposes).
// Overloading 'userData' as the gate caused a bug: once it was set even
// partially (e.g. just sub_id, before signup was finished), later remounts
// would skip the onboarding check entirely and render the Outlet directly.
const ONBOARDING_COMPLETE_KEY = 'onboardingComplete';

export default function Dashboard() {
  const [loading, setLoading] = useState(false)
  const {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    logout
  } = useAuth0();
  const navigate = useNavigate();
  const [loginClicked, setLoginClicked] = useState(false)
  const [logoutClicked, setLogoutClicked] = useState(false)
  const [token, setToken] = useState('')
  const [uiLoading, setUiLoading] = useState(true)
  const localUserData = JSON.parse(localStorage.getItem('userData')) || ''
  const [localData, setLocalData] = useState(localUserData)
  const [notifications, setNotifications] = useState([]);
  const storedToken = localStorage.getItem('token');

  // Prevents the onboarding-check branch from firing more than once per
  // authenticated session, even if this effect re-runs because Auth0 gives
  // us new function/object identities for getAccessTokenSilently/logout/user
  // (which happens more than you'd expect, and was the actual source of the
  // race you were hitting — two overlapping checkSubIdArraival calls, one of
  // which could hit "Unknown or invalid refresh token" and force a logout
  // mid-flight, or the two calls could just disagree on localStorage state).
  const onboardingCheckRanRef = useRef(false);

  const checkSubIdArraival = async (auth0Id) => {
    try {
        localStorage.setItem("disclaimer_popup",true)
      const response = await ApiService().post('users/by-auth0Id', { auth0Id: auth0Id })
      console.log("response?.data?.user?.userId ", response?.data?.user)
      const { firstName, lastName } = response?.data?.user;
      localStorage.setItem("firstName", firstName)
      localStorage.setItem("lastName", lastName)
      console.log("DOB ", response?.data?.user, response?.data?.user?.dateOfBirth)

      if (response?.data?.user?.dateOfBirth) {
        verifyQuestionarComplete(response?.data?.user?.userId)
      } else {
        console.log("within else ", response)
        // Onboarding NOT complete yet. Cache the auth0 user for display,
        // but explicitly make sure the onboarding-complete flag is absent.
        localStorage.setItem('userData', JSON.stringify(user))
        localStorage.removeItem(ONBOARDING_COMPLETE_KEY)
        setUiLoading(false)
        console.log("Before navigate");
        navigate("/Signup", { replace: true });
        console.log("After navigate");
      }

    } catch (error) {
      captureException(error)
      setUiLoading(false)
    }
  }
  console.log("uiLoading ", uiLoading)

  useEffect(() => {
    if (localStorage.getItem('login') && !isAuthenticated) setLoading(true)
  }, [isAuthenticated])

  const verifyQuestionarComplete = async (user_id) => {
    console.log("user_id ", user_id)
    try {
      const response = await ApiService().get(`users/${user_id}/onboarding/status`)
      if (response?.data?.status) {
        if (response?.data?.status?.completedQuestionnaire == false && !localStorage.getItem('questionaire_skipped')) {
          setLoading(false)
          setUiLoading(false)
          navigate('/Questionnaire')
          return
        }
      }
      // Only now — dateOfBirth present AND questionnaire complete (or
      // skipped) — is onboarding actually finished. Cache that so future
      // mounts can skip the API round-trip entirely.
      localStorage.setItem('userData', JSON.stringify(user))
      localStorage.setItem(ONBOARDING_COMPLETE_KEY, 'true')
      setLoading(false)
      setUiLoading(false)
    } catch (error) {
      setLoading(false)
      setUiLoading(false)
      captureException(error)
    }
  }

  useEffect(() => {
    subscribeToMessages();
  }, []);

  useEffect(() => {
    const handleLoading = async () => {
      if (isAuthenticated && user) {
        try {
          setLoading(true);

          const res = await getAccessTokenSilently();
          localStorage.setItem('token', res);
          setToken(res);

          const onboardingComplete = localStorage.getItem(ONBOARDING_COMPLETE_KEY) === 'true';

          if (onboardingComplete) {
            // Verified complete on a previous run — safe to trust the cache.
            console.log("Onboarding already verified complete, setting userData again");
            localStorage.setItem('userData', JSON.stringify(user));
            setUiLoading(false);
          } else if (!onboardingCheckRanRef.current) {
            // Not yet verified complete for this session — always run the
            // real check exactly once. The ref guard is what stops a second,
            // overlapping effect run (triggered by a new getAccessTokenSilently
            // or logout reference) from firing checkSubIdArraival again while
            // the first call is still in flight.
            onboardingCheckRanRef.current = true;
            console.log("Checking subscription for", user, user?.sub);
            await checkSubIdArraival(user?.sub);
          }

        } catch (error) {
          if (error?.message === "Unknown or invalid refresh token.") {
            await invalidateSession()
            await logoutAfterTokenExpired();
            localStorage.clear();
            localStorage.setItem('logout', true);
            logout({ logoutParams: { returnTo: window.location.origin } })
          } else {
            console.error("Error in handleLoading:", error);
          }
        } finally {
          setLoading(false);
        }
      }
    };

    handleLoading();
  }, [isAuthenticated, user, getAccessTokenSilently, logout]);

  const rawAxios = axios.create();

  const checkAlreadyLoggedIn = async (token, userId, issuedAt) => {
    try {
      console.log("ihave ", storedToken)
      const response = await rawAxios.post(`${process.env.REACT_APP_BASE_URL}users/${userId}/sessions`, { issuedAt: issuedAt }, { headers: { 'Authorization': `Bearer ${token ? token : null}` } })
      console.log("alreadfy response ", response)
    } catch (error) {
      console.log("checkAlreadyLoggedIn error ", error)
    }
  }

  const invalidateSession = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}users/${user?.sub_id}/sessions/invalidate`, {}, { headers: { 'Authorization': `Bearer ${storedToken ? storedToken : null}` } })
    } catch (error) {
      console.log("invalidateSession error ", error)
    }
  }

  const logoutAfterTokenExpired = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_BASE_URL}oauth/logout`, { headers: { 'Authorization': `Bearer ${storedToken ? storedToken : null}` } })
    } catch (error) {
      console.log("logoutAfterTokenExpired error ", error)
    }
  }

  useEffect(() => {
    if (!isAuthenticated && (loginClicked)) {
      setLoading(false)
      setLoginClicked(false)
      localStorage.removeItem('logout')
    }
  }, [isAuthenticated])

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(true)
    }
  }, [isAuthenticated])

  useEffect(() => {
    if (storedToken && user && isAuthenticated) {
      setLoading(false)
    }
  }, [storedToken, user, isAuthenticated])

  if (loading && (!token && !localStorage.getItem("token"))) return (
    <Box sx={{ width: '100vw', height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <CircularProgress size="lg" sx={{ width: "80px", height: "80px" }} />
    </Box>
  )

  if (uiLoading) return (
    <Box sx={{ width: '100vw', height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <CircularProgress size="lg" sx={{ width: "80px", height: "80px" }} />
    </Box>
  )

  return (<>

    {storedToken &&
      (<SideBar setLogoutClicked={setLogoutClicked} logoutClicked={logoutClicked}>
        <Box sx={{ margin: "0 auto", width: "100%" }}>
          <Box sx={{ width: "100%" }}>
            <StyledToastContainer limit={3} />
          </Box>
          <Outlet />
        </Box>
      </SideBar>)}

  </>

  );
}